import React from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { StoreLinks } from "../../../../../StoreLinks";
import style from "./styles.pcss";
var cn = classNames.bind(style);
var STORES_BLOCK_TEXTS = {
  title: 'скачай мобильное приложение'
};
export var StoresBlock = function StoresBlock(_ref) {
  var storeLinks = _ref.storeLinks,
    storeIcons = _ref.storeIcons;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    className: cn('stores-title'),
    color: "secondary-invert",
    size: "xs"
  }, STORES_BLOCK_TEXTS.title), /*#__PURE__*/React.createElement("div", {
    className: cn('stores')
  }, /*#__PURE__*/React.createElement(StoreLinks, {
    icons: storeIcons,
    stores: storeLinks
  })));
};